
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'FlowDuration',
})
export default class FlowDuration extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  schema: any;

  @Prop({
    type: Object,
    required: true,
  })
  data: any;

  @Prop({
    type: Object,
    required: true,
  })
  value: {
    companyId: number;
    contactId: number;
    leadId: number;
  };

  get computedCross() {
    if (this.value) {
      if (this.value.companyId) {
        return {
          id: this.value.companyId,
          type: this.$enums.BusinessObjectType.Company,
        };
      }
      if (this.value.contactId) {
        return {
          id: this.value.contactId,
          type: this.$enums.BusinessObjectType.Contact,
        };
      }
      if (this.value.leadId) {
        return {
          id: this.value.leadId,
          type: this.$enums.BusinessObjectType.Lead,
        };
      }
    }
    return { id: 0, type: 0 };
  }

  update(value) {
    if (value == null) {
      this.$emit('input', null);
    } else {
      this.$emit('input', {
        companyId: value.type === this.$enums.BusinessObjectType.Company ? value.id : 0,
        contactId: value.type === this.$enums.BusinessObjectType.Contact ? value.id : 0,
        leadId: value.type === this.$enums.BusinessObjectType.Lead ? value.id : 0,
      });
    }
  }
}
